// shared/services/alert.service.ts
import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  public question(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-primary me-2 mt-2',
        cancelButton: 'btn btn-danger mt-2',
      },
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      buttonsStyling: false,
      showCloseButton: true,
    });
  }

  public success(text: string) {
    Swal.fire({
      text,
      icon: 'success',
      buttonsStyling: false,
      confirmButtonText: 'Ok, got it!',
      customClass: {
        confirmButton: 'btn btn-success',
      },
    });
  }

  public error(text: string) {
    Swal.fire({
      text,
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: 'Aceptar',
      customClass: {
        confirmButton: 'btn btn-danger',
      },
    });
  }
}
